var _a, _b, _c, _d;
import { generateActions } from "../generators/generator.actions";
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./rentRegistrationDocuments.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["AddRegistrationDocument"] = "ADD_REGISTRATION_DOCUMENT";
    EActionCustom["UpdateRegistrationDocument"] = "UPDATE_REGISTRATION_DOCUMENT";
    EActionCustom["DeleteRegistrationDocument"] = "DELETE_REGISTRATION_DOCUMENT";
})(EActionCustom || (EActionCustom = {}));
export var getPagedStart = (_a = generateActions(GENERATOR_PARAMS), _a.getPagedStart), getPagedStartNoThrottle = _a.getPagedStartNoThrottle, getPagedSucceeded = _a.getPagedSucceeded, getPagedFailed = _a.getPagedFailed, getCountStart = _a.getCountStart, getCountStartNoThrottle = _a.getCountStartNoThrottle, getCountSucceeded = _a.getCountSucceeded, getCountFailed = _a.getCountFailed;
var generateAddRegistrationDocumentActions = function () { return ({
    addRegistrationDocumentStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddRegistrationDocument,
        state: EActionState.Start,
    }),
    addRegistrationDocumentSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddRegistrationDocument,
        state: EActionState.Success,
    }),
    addRegistrationDocumentFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.AddRegistrationDocument,
        state: EActionState.Fail,
    }),
}); };
var generateUpdateRegistrationDocumentActions = function () { return ({
    updateRegistrationDocumentStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateRegistrationDocument,
        state: EActionState.Start,
    }),
    updateRegistrationDocumentSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateRegistrationDocument,
        state: EActionState.Success,
    }),
    updateRegistrationDocumentFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateRegistrationDocument,
        state: EActionState.Fail,
    }),
}); };
var generateDeleteRegistrationDocumentActions = function () { return ({
    deleteRegistrationDocumentStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.DeleteRegistrationDocument,
        state: EActionState.Start,
    }),
    deleteRegistrationDocumentSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.DeleteRegistrationDocument,
        state: EActionState.Success,
    }),
    deleteRegistrationDocumentFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.DeleteRegistrationDocument,
        state: EActionState.Fail,
    }),
}); };
export var addRegistrationDocumentStart = (_b = generateAddRegistrationDocumentActions(), _b.addRegistrationDocumentStart), addRegistrationDocumentSucceeded = _b.addRegistrationDocumentSucceeded, addRegistrationDocumentFailed = _b.addRegistrationDocumentFailed;
export var updateRegistrationDocumentStart = (_c = generateUpdateRegistrationDocumentActions(), _c.updateRegistrationDocumentStart), updateRegistrationDocumentSucceeded = _c.updateRegistrationDocumentSucceeded, updateRegistrationDocumentFailed = _c.updateRegistrationDocumentFailed;
export var deleteRegistrationDocumentStart = (_d = generateDeleteRegistrationDocumentActions(), _d.deleteRegistrationDocumentStart), deleteRegistrationDocumentSucceeded = _d.deleteRegistrationDocumentSucceeded, deleteRegistrationDocumentFailed = _d.deleteRegistrationDocumentFailed;
